'use client';

import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import Image from 'next/image';
import { Suspense } from 'react';

import { authClient } from '@/lib/auth-client';
import { LocaleSwitcher } from '@/lib/LocaleSwitcher';
import { safeCallbackUrl } from '@/lib/safe-callback-url';
import styles from '@/styles/Home.module.css';

function SignInForm() {
  const t = useTranslations('signIn');
  const searchParams = useSearchParams();
  const callbackUrl = safeCallbackUrl(searchParams.get('callbackUrl'));

  return (
    <main className={styles.main} data-lk-theme="default">
      <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
        <LocaleSwitcher />
      </div>
      <div className="header">
        <Image
          src="/images/scoville-meet-home.svg"
          alt="Scoville Meet"
          width={279}
          height={58}
          priority
        />
        <h2>{t('heading')}</h2>
      </div>
      <div className={styles.tabContent}>
        <p style={{ marginTop: 0 }}>{t('workspaceRestriction')}</p>
        <button
          className="lk-button"
          type="button"
          onClick={() =>
            authClient.signIn.social({
              provider: 'google',
              callbackURL: callbackUrl,
            })
          }
        >
          {t('signInWithGoogle')}
        </button>
      </div>
    </main>
  );
}

export default function SignInPage() {
  const t = useTranslations('common');
  return (
    <Suspense fallback={t('loading')}>
      <SignInForm />
    </Suspense>
  );
}
